import AuthUserStore from '@/common/utils/AuthUser';

const AUTH_TOKEN_KEY = 'RES_AUTH_TOKEN';

const isJWTExpired = (token: string) => {
  if (!token) return true;
  const jwtPayload = token.split('.')[1];
  const decodedPayload = JSON.parse(atob(jwtPayload));
  const expiry = decodedPayload.exp;
  return Date.now() >= expiry * 1000;
};

export const getAuthToken = () => {
  const token = localStorage.getItem(AUTH_TOKEN_KEY) || '';

  if (token) {
    if (isJWTExpired(token)) {
      console.log('Request blocked: JWT is expired.');
      return Promise.reject(new Error('JWT is expired'));
    }
  } else {
    console.log('Request blocked: No JWT found.');
    AuthUserStore.logout();
    return Promise.reject(new Error('No JWT found'));
  }

  return token;
};
